/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useRef, useState, useEffect, useImperativeHandle } from 'react';
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import usePrevious from "../../../../Shared/components/Previous";
import { Box } from "@mui/material";
import { HeaderView, LineView } from "./Blocks";
import { toast } from 'react-toastify';
import { AESEncrypt } from "../../../../../helpers/Crypto";
import managementActions from "../../../Management/redux/actions";
import unitActions from "../../../../Product/Setup/redux/actions";
import productActions from "../../../../Product/Product/redux/actions";
import { idNamingConversion, checkComponentPermission, capitalizeFirstLetter, getColumnWidth, checkCRUDPermission, exportCommonFile } from '../../../../../helpers/utilities';
import { useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import { customSort } from '../../../../../helpers/sort';

export const CustomForm = React.forwardRef((props, ref) => {
    const { showDetails, view, classes, clsx, type, dispatch, history } = props;
    const childRef = useRef('');
    const { getData } = useSelector(state => state.crudReducer);
    const [loadMore, setLoadMore] = useState(false);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);

    const { createDetails, createError, createLoader, editLoader } = useSelector(state => state.crudReducer);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const [form, setForm] = useState([]);
    const [error, setError] = useState([]);
    const [lines, setLines] = useState([]);
    const [allLinesData, setAllLinesData] = useState([]);
    const [allLines, setAllLines] = useState([]);
    const [dLines, setDLines] = useState([]);
    const [search, setSearch] = useState('');
    const [customerProductsLoad, setCustomerProductsLoad] = useState(true);
    const timeoutRef = useRef(null);
    const prevSearch = usePrevious(search);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");


    const changeCustomer = (value) => {
        if (value?.isHold) {
            setError({
                ...error,
                customerId: 'Please release the Customer from ON-HOLD to allow for transaction to be processed.'
            });
            setForm({});
        } else {
            setError({
                ...error,
                customerId: false
            });
            setForm({
                ...form,
                customerName: value?.name,
                mobile: value?.mobile,
                email: value?.email,
                customerId: value?.id,
            });
            setLoadMore(false);
            dispatchFilter(value?.id);
        }
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            let a = allLines;
            if (search === '') {
                a = allLines;
                setLines(a);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    a = allLines?.filter((el) => {
                        return (el?.product?.productName?.match(new RegExp(search, "i")) ||
                            el?.product?.productId?.match(new RegExp(search, "i")) ||
                            el?.status?.match(new RegExp(search, "i")) ||
                            el?.unit?.name?.match(new RegExp(search, "i")))
                    });
                    setLines(a);
                }, 500);
            }
        }
    }, [search]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            if (customerProductsLoad) {
                setLoadMore(true);
                setLines([...getData]);
                setAllLines([...getData]);
                setAllLinesData([...getData]);
            }
        }
    }, [getData]);

    useEffect(() => {
        loadTasks();
    }, []);

    const loadTasks = () => {
        if (type === 'create') {
            customerApi();
        }
        setLoadMore(true);
        productApi('');
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });
    }

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        filter['and'].push(or);

        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const handleProductEdit = (t) => {
        history.push(`/sales/setup/customer-products/${AESEncrypt({ 'customerId': form?.customerId, 'customerName': form.customerName })}/${t}`, `${t}`);
    }

    const customerApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: managementActions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    useImperativeHandle(ref, () => ({
        onEdit(values) {
            let c = parseInt(values?.customerId);
            customerApi('', c);
            setForm({ customerId: c, customerName: values?.customerName, mobile: values?.mobile, email: values?.email });
            dispatchFilter(c);
        }
    }))

    const dispatchFilter = (customerId) => {
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: `v1/schedules/customer-products`,
            skip: 0,
            filter: {
                where: { 'customerId': customerId },
                order: 'id desc'
            }
        });
        setCustomerProductsLoad(true);
    }

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyCustomer = emptyValidation('Customer', form?.customerId, 'dropdown');
        if (emptyCustomer.isValid) {
            let a = {};
            let l = [];
            lines && lines?.length > 0 && lines?.map((element, i) => {
                return l.push({ ...element })
            });
            l?.length > 0 && l?.map((element, i) => {
                delete element.product;
                delete element.discountRate; delete element.discountType; delete element.excisesAmount; delete element.excisesApplicable;
                delete element.customer; delete element.excisesSplAmount; delete element.excisesSplType; delete element.excisesTotal;
                delete element.excisesType; delete element.includeGst; delete element.salesValue; delete element.stockQuantity; delete element.stockUnit;
                delete element.stockUnitId; delete element.totalCostPrice;
                delete element.unit;
                delete element.business; delete element.hsn;
                return l.splice(i, 1, { ...element });
            });
            let n = l.length > 0 ? l.filter((el) => { return !el.id; }) : [];
            let updated = l.length > 0 ? l.filter((el) => { return el.id && el.updated; }) : [];
            a.new = [...n];
            a.update = [...updated];
            a.new?.length > 0 && a.new?.map((element, i) => {
                delete element.updated;
                return a.new.splice(i, 1, { ...element });
            });
            a.update?.length > 0 && a.update?.map((element, i) => {
                delete element.updated;
                return a.update.splice(i, 1, { ...element });
            });
            a.delete = [...dLines];
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: "/v1/schedules/customer-products",
                title: "Customer Products",
                details: a
            })
        } else {
            setError({
                customerId: emptyCustomer.errors
            })
        }
        childRef?.current?.handleAdjustHeight();
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            history.push(`/sales/setup/customer-products/${AESEncrypt({ 'customerId': form?.customerId, 'customerName': form?.customerName, 'mobile': form?.mobile, 'email': form?.email, })}/view`, `${type}`);
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            toast.dismiss();
            toast.error(text);
        }
        childRef?.current?.handleAdjustHeight();
    }, [createDetails, createError]);

    const lineSubmit = (data, lineId = '') => {
        if (lineId !== '') {
            let index = lines.findIndex((d, i) => lineId === i);
            if (index >= 0) {
                data.updated = true;
                lines.splice(index, 1, data);
                allLines.splice(index, 1, data);
            }
        } else {
            setLines((prevState) => {
                return [...prevState, data];
            });
            setAllLines((prevState) => {
                return [...prevState, data];
            });
        }
    }

    const lineBulkSubmit = (data) => {
        setLines(data);
        setAllLines(data);
    }

    const deleteLine = (id) => {
        let index = lines.findIndex((d, i) => id === i);
        let fLines = lines.find((d, i) => id === i);
        if (index >= 0) {
            delete fLines.product;
            delete fLines.business;
            delete fLines.salesUnit;
            delete fLines.skuUnit;
            delete fLines.universalProduct; delete fLines.customer;
            setDLines([
                ...dLines, fLines
            ]);
            lines.splice(index, 1);
            setAllLines([...lines]);
        }
    }

    const deleteBulkLine = (el) => {
        delete el.product;
        delete el.business;
        delete el.salesUnit;
        delete el.skuUnit;
        delete el.universalProduct; delete el.customer;
        setDLines((prevState) => {
            return [...prevState, el];
        });
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        customSort(sortBy, sortOrder, lines);
    }

    return (
        <Fragment>
            <CustomAccordion
                title={'Customer Products'}
                top={"0"}
                topVisible={"50px"}
                zIndex={9}
                showDetails={showDetails}
                index={0}
                ref={childRef}
                component={
                    <Box
                        className={clsx(classes.removeUnderline, classes.positionRelative)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => handleSubmit(e)}>
                        {
                            showDetails ? <div className={classes.textAlignCenter}>
                                <div className={classes.loadMoreCircle}></div>
                            </div> : <HeaderView
                                {...props}
                                form={form}
                                error={error}
                                view={view}
                                handleProductEdit={(t) => handleProductEdit(t)}
                                changeCustomer={(data) => changeCustomer(data)}
                                loader={createLoader || editLoader}
                                customerApi={(search = '', id = '') => customerApi(search, id)}
                                customObject={(details, id) => customObject(details, id)}
                                idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                customerDetails={customerDetails}
                            />
                        }
                    </Box>
                }
            />
            <CustomAccordion
                title={'Products Lines'}
                top={"49"}
                topVisible={"150px"}
                zIndex={7}
                showDetails={showDetails}
                index={1}
                ref={childRef}
                component={
                    <LineView
                        {...props}
                        lines={lines}
                        allLines={allLines}
                        allLinesData={allLinesData}
                        headerView={view}
                        form={form}
                        productApi={(s = '', id = '') => productApi(s, id)}
                        loadMore={loadMore}
                        sortOrder={sortOrder}
                        sortBy={sortBy}
                        onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                        handleSearch={(s) => setSearch(s)}
                        dispatch={dispatch}
                        unitMesurementdetails={unitMesurementdetails}
                        myProductdetails={myProductdetails}
                        exportCommonFile={(name, data = 'existing', selected = [], extension = 'xlsx') => exportCommonFile(name, data, selected, extension)}
                        getColumnWidth={(head, v) => getColumnWidth(head, v)}
                        lineSubmit={(data, id = '') => lineSubmit(data, id)}
                        lineBulkSubmit={(data) => lineBulkSubmit(data)}
                        productActions={productActions}
                        handleMyProductsLoad={() => setCustomerProductsLoad(false)}
                        capitalizeFirstLetter={(v) => capitalizeFirstLetter(v)}
                        deleteLine={(id) => deleteLine(id)}
                        deleteBulkLine={(id) => deleteBulkLine(id)}
                        customObject={(details, id) => customObject(details, id)}
                        idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                        checkCRUDPermission={(feature, type, name) => checkCRUDPermission(feature, type, name)}
                        checkComponentPermission={(feature, type, name) => checkComponentPermission(feature, type, name)}
                        search={search}
                    />
                }
            />
        </Fragment>
    )
})